import React from 'react';
import ContactForm from '../ContactFrom'


const Contactpage = () => {

    return (
        <section className="wpo-contact-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-10 offset-lg-1">
                        {/* <div className="office-info"> */}
                        {/* <div className="row"> */}
                        {/* <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-location"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Address</h2>
                                            <p>Al Fawz 3rd - Office M205, Dubai</p>
                                        </div>
                                    </div>
                                </div> */}
                        {/* <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-email"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Email Us</h2>
                                            <p>info@maakdream.com</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-telephone"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Call Now</h2>
                                            <p>04 5546928 | 055 8690761</p>
                                        </div>
                                    </div>
                                </div> */}
                        {/* </div> */}
                        {/* </div> */}
                        <div className="wpo-contact-title">
                            <h2>Have Any Question?</h2>
                            {/* <p>It is a long established fact that a reader will be distracted
                                content of a page when looking.</p> */}
                        </div>
                        <div className="wpo-contact-form-area">
                            <ContactForm />
                        </div>
                    </div>
                </div>
            </div>
            <section className="wpo-contact-map-section" style={{ marginTop: '120px' }}>
                <div className="wpo-contact-map">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d115554.81722741463!2d55.237888!3d25.166505000000004!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f699e89d6e71f%3A0xa6d71009ce760d97!2sMaakdream%20Properties!5e0!3m2!1sen!2sus!4v1755077748410!5m2!1sen!2sus" width="800" height="600" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </section>
        </section>
    )

}

export default Contactpage;
